import ContentWrapper from "@/components/wrappers/ContentWrapper";
import DisplayWrapper from "@/components/wrappers/DisplayWrapper";
import { Card } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useAdminGetUser } from "../../../common/api/queries";
import ActionButton from "../../../common/components/buttons/ActionButton";
import BackNavigationArrow from "../../../common/components/views/BackNavigationArrow";
import { EntityIdObject } from "../../../common/types";
import { AdminCreateUserAccountForm } from "../components/forms/AdminCreateUserAccountForm";
import { AdminUpdateUserAccountForm } from "../components/forms/AdminUpdateUserAccountForm";
import { AdminUpdateUserForm } from "../components/forms/AdminUpdateUserForm";
import { AdminUserDetailView } from "../components/views/detail/AdminUserDetailView";
import { AgentUserAccount } from "../types";

export const AdminUserDetailContainer = () => {
  const { t } = useTranslation();

  const { id } = useParams<EntityIdObject>() as { id: string };

  const { data: user, isError } = useAdminGetUser(id);

  const [userUpdateFormOpen, setUserUpdateFormOpen] = useState(false);
  const [userAccountCreateFormOpen, setUserAccountCreateFormOpen] = useState(false);
  const [updatedUserAccount, setUpdatedUserAccount] = useState<AgentUserAccount>();

  return (
    <ContentWrapper>
      <DisplayWrapper itemLoaded={!!user} isError={isError}>
        {user && (
          <Card
            className="card-box"
            title={
              <BackNavigationArrow>
                <h2>{user.name}</h2>
              </BackNavigationArrow>
            }
          >
            <AdminUserDetailView
              user={user}
              onUpdateUserClick={() => setUserUpdateFormOpen(true)}
              onUpdateUserAccountClick={setUpdatedUserAccount}
            />

            <AdminUpdateUserForm
              open={userUpdateFormOpen}
              user={user}
              onFormCancel={() => setUserUpdateFormOpen(false)}
            />

            <AdminCreateUserAccountForm
              open={userAccountCreateFormOpen}
              user={user}
              onFormCancel={() => setUserAccountCreateFormOpen(false)}
            />

            <AdminUpdateUserAccountForm
              open={!!updatedUserAccount}
              user={user}
              account={updatedUserAccount}
              onFormCancel={() => setUpdatedUserAccount(undefined)}
            />

            <ActionButton icon="plus" className="margin-top-small" onClick={() => setUserAccountCreateFormOpen(true)}>
              {t("user.actions.addAccount")}
            </ActionButton>
          </Card>
        )}
      </DisplayWrapper>
    </ContentWrapper>
  );
};
